var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3a1 1 0 011-1h8.589a1 1 0 01.704.29l2.72 2.698 2.699 2.735a1 1 0 01.288.703V21a1 1 0 01-1 1H5a1 1 0 01-1-1V3zm8.603.996v5.236l5.36-.014V20H5.965V4l6.637-.004z",
    fill: "#9CA6AD"
  })));
};

export default SvgFile;